import { ChildrenBlock, useEditor } from '@smartfire/glue-ui/block';
import { InnerBlocks } from '@wordpress/block-editor';
import { registerBlock } from '@smartfire/glue-ui';

import styles from './block.module.scss';

const Block = () => {
    const { isEditing } = useEditor();

    return (
        <div className={styles.block}>
            {isEditing ? (
                <div className={styles.innerBlocksWrapper}>
                    <InnerBlocks
                        allowedBlocks={[
                            'core/heading',
                            'core/link',
                            'core/paragraph',
                            'core/image',
                            'core/columns',
                            'core/separator',
                            'smartfire/button',
                            'smartfire/spacer',
                        ]}
                    />
                </div>
            ) : (
                <div className={styles.childrenBlockWrapper}>
                    <ChildrenBlock />
                </div>
            )}
        </div>
    );
};

export default registerBlock(
    'textual-content',
    {
        Block,
        smartProps: {},
        setup: {
            title: 'Contenu textuel',
        },
    },
    'smartfire',
);
